/**
 * Display label helpers for sensitive backend role names.
 * Internal role names (e.g. "super_admin") MUST remain stable for RBAC checks.
 * These helpers ONLY transform the visible label.
 */
export function displayRole(role) {
  if (!role) return "—";
  // Per user request iter24: hide "super_admin" label as generic "Unknown".
  if (role === "super_admin") return "Unknown";
  return role;
}
